import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import Panel from '../../components/panel/panel';
import './account.less';
import { fetchLenderAccount } from './accountActions';
import { getError, isBusy, withActions } from 'actionware';
import * as numeral from 'numeral';
import { Alert, Spin } from 'antd';
import Button from '../../components/button/button';
import * as R from 'ramda';
import { moneyFormat } from '../../common/constants';
import Section from '../../components/section/section';
import WithdrawalModal from '../withdrawal/withdrawalModal';
import { toggleWithdrawalModal } from '../withdrawal/withdrawalActions';
import { toggleAccountCreationModal } from '../accountCreation/accountCreationActions';
import { fetchProfileData } from '../profile/profileActions'
import { capitalize } from '../../common/helpers';
import { push } from 'connected-react-router';
import investmentAccountIcon from '../../assets/investment_account.svg';
import { bindActionCreators } from 'redux';

const { REACT_APP_FASPAY_USER, REACT_APP_FASPAY_PASS } = process.env

const base64AuthKey = Buffer.from(`${REACT_APP_FASPAY_USER}:${REACT_APP_FASPAY_PASS}`).toString('base64')

@connect(
  ({
    localize,
    account: {
      selectedAccountDetails,
      activeLoans,
      repaidLoans,
      editedInvestmentAccount,
      accounts
    },
    session: {
      user
    }
  }) => ({
    translate: getTranslate(localize),
    currentLanguage: getActiveLanguage(localize).code,
    loading: isBusy(fetchLenderAccount) || R.isEmpty(selectedAccountDetails),
    error: getError(fetchLenderAccount),
    selectedAccountDetails,
    activeLoans,
    repaidLoans,
    editedInvestmentAccount,
    accounts,
    user
  }),
  dispatch => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  fetchLenderAccount,
  toggleWithdrawalModal,
  toggleAccountCreationModal,
  fetchProfileData
})
export default class AccountDetails extends PureComponent {
  constructor() {
    super()
    this.state = {
      bca_va: null,
      permata_va: null
    }
  }
  componentWillMount = () => {
    this.props.fetchProfileData()
  }

  componentWillReceiveProps = (prevProps, prevState) => {
    const accountId = prevProps.accounts[0].id // assume only show one lender account
    
  }

  onClickWithdraw = () => {
    this.props.toggleWithdrawalModal();
  };

  onClickTopUp = () => {
    alert('Under development');
  };

  onClickEditAccount = () => {
    return this.props.toggleAccountCreationModal('edit');
  };

  onClickAddAccount = (e) => {
    return this.props.toggleAccountCreationModal('create');
  };

  onClickChangeAccount = accountId => () =>
    this.props.push(`/account/${accountId}`);

  get accountButtons() {
    const { selectedAccountDetails, accounts, fetchingDetails } = this.props;
    // const showAddButton = accounts && accounts.length < 4;
    return (
      <div key={1} className={'account-buttons no-mobile inline-buttons'}>
        {/* <WithdrawalModal /> */}
        {accounts.map(({ id, name }, key) => (
          <Button
            disabled={fetchingDetails}
            key={key}
            onClick={this.onClickChangeAccount(id)}
            active={selectedAccountDetails.id === id}
          >
            {capitalize(name)}
          </Button>
        ))}
        { /* showAddButton && (
          <Button className={'add-account'} onClick={this.onClickAddAccount}>
            +
          </Button>
        ) */ }
      </div>
    );
  }

  get accountButtonsMobile() {
    const { translate } = this.props;
    return (
      <div key={2} className={'account-buttons mobile inline-buttons'}>
        {/* <Button onClick={this.onClickTopUp}>
          {translate('account.topUp')}
        </Button>
        <Button onClick={this.onClickWithdraw}>
          {translate('account.withdraw')}
        </Button> */}
      </div>
    );
  }

  wrapInSection(content) {
    const { translate, selectedAccountDetails: { name } } = this.props;
    return (
      <Section
        className={'account-details'}
        title={
          <span>
            <span className={'no-mobile'}>
              {translate('account.investmentTitle')}
            </span>
            <span className={'mobile'}>{name}</span>
          </span>
        }
        icon={investmentAccountIcon}
        // extra={
        //   <Button onClick={this.onClickWithdraw}>
        //     {translate('account.withdraw')}
        //   </Button>
        // }
      >
        {content}
      </Section>
    );
  }

  splitVaNumber(number) {
    if (!number) return '-'
    return number.match(/.{1,4}/g).join(' ');
  }

  render() {
    const million = 1000000;

    const {
      translate,
      loading,
      error,
      selectedAccountDetails: {
        tenor,
        minInvestment,
        maxInvestment,
        riskCategory,
        balance,
        loanAmount,
        realized_profit,
        va_bni,
        va_bri,
        va_mandiri,
        va_bca,
        va_permata
      },
      activeLoans,
      repaidLoans
    } = this.props;
    if (loading) {
      return this.wrapInSection(
        <Spin tip={translate('generic.loadingData')} size="large" />
      );
    }

    if (error) {
      return this.wrapInSection(
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }

    return this.wrapInSection(
      [
        this.accountButtons,
        this.accountButtonsMobile,
        <div key={3} className={'content'}>
          <Panel title={translate('account.preferenceDetail')} className={'preference-details'}
            footer={
              <a className={'top'} onClick={this.onClickEditAccount}>
                {translate('account.edit')}
              </a>
            }
          >
            <dl>
              <dt></dt>
              <dd></dd>
              { /*<dt>{translate('account.investmentCategory')}</dt>
              <dd>
                {translate('account.investmentCategories', {
                  count: investmentCategories.length
                })}
                <Info
                  tooltipContent={
                    <ul>
                      {investmentCategories.map((category, key) => (
                        <li key={key}>{category}</li>
                      ))}
                    </ul>
                  }
                />
            </dd> */}
              <dt>{translate('account.tenor')}</dt>
              <dd>
                {
                  tenor === 'all' ?
                    'Any' :
                    tenor
                      .sort((a,b) => a - b)
                      .map(m => m.slice(0, m.length - 1))
                      .map(m => `${m} Month${(Number(m) > 1 && 's') || ''}`)
                      .join(', ')
                }
              </dd>
            </dl>
            <dl>
              <dt>{translate('account.loanAmount')}</dt>
              <dd>
                {loanAmount === 'preferred' ? translate('account.loanAmountValue', {
                  min:
                    Number(minInvestment) >= million
                      ? numeral(+(Number(minInvestment) / million).toFixed(2)).format('0,0')
                      : Number(minInvestment),
                  max:
                    Number(maxInvestment) >= million
                      ? numeral(+(Number(maxInvestment) / million).toFixed(2)).format('0,0')
                      : Number(maxInvestment),
                  suffix: translate('account.million')
                }) : capitalize(loanAmount)}
              </dd>
              <dt>{translate('account.riskCategory')}</dt>
              <dd>
                {riskCategory &&
                  translate('account.riskCategoryValue', {
                    value: riskCategory === 'all' ? capitalize('any') : riskCategory.map(risk => capitalize(risk)).join(', ')
                  })}
              </dd>
            </dl>
          </Panel>
          <Panel title={translate('account.realizedProfit')} className={'currently-disbursed'}>
            <h1>
              {translate('generic.amount', {
                value: numeral(realized_profit).format(moneyFormat)
              })}
            </h1>
          </Panel>
          <Panel title={translate('account.activeLoans')} className={'active-loans'}>
            {activeLoans && (
              <h1>
                {activeLoans.length === 1
                  ? translate('account.singleLoan')
                  : translate('account.loansCount', {
                      count: activeLoans.length
                    })}
              </h1>
            )}
          </Panel>
          <Panel title={translate('account.currentBalance')} className={'current-balance'}>
            <h1>
              {translate('generic.amount', {
                value: numeral(balance).format(moneyFormat)
              })}
            </h1>
          </Panel>
          <Panel title={translate('account.fullyPaidLoan')} className={'paid-loans'}>
            {repaidLoans && (
              <h1>
                {repaidLoans.length === 1
                  ? translate('account.singleLoan')
                  : translate('account.loansCount', {
                      count: repaidLoans.length
                    })}
              </h1>
            )}
          </Panel>
          {/* <Panel title={translate('account.topUp')} className={'top-up'}>
            <div style={{width: '100%'}}>
              <span className="virtual-accounts-title">BNI Virtual Account</span>
              <span className="virtual-accounts-value">{this.splitVaNumber(va_bni)}</span>
              <span className="virtual-accounts-title">BRI Virtual Account</span>
              <span className="virtual-accounts-value">{this.splitVaNumber(va_bri)}</span>
              <span className="virtual-accounts-title">Mandiri Virtual Account</span>
              <span className="virtual-accounts-value">{this.splitVaNumber(va_mandiri)}</span>
              <span className="virtual-accounts-title">BCA Virtual Account</span>
              <span className="virtual-accounts-value">{this.splitVaNumber(va_bca)}</span>
              <span className="virtual-accounts-title">Permata Virtual Account</span>
              <span className="virtual-accounts-value">{this.splitVaNumber(va_permata)}</span>
            </div>
          </Panel> */}
        </div>
      ]
    );
  }
}
